import {
  each, extend, map, noop,
} from 'lodash';
import ApplicationController, { EVENTO_CONTROLLER_CARGADO } from '../application_controller';

/**
 *
 * @param {*} idProfesor Tiene que ser un integer
 * @param {*} data
 * @returns
 */
function filtrarCuadernosValidos(idProfesor, data) {
  return data.filter((cuaderno) => {
    // Si no es evaluable no se pueden importa items
    if (cuaderno.asignatura.evaluable_tipo === 'no_evaluable') {
      return false;
    }

    const cuadernoProfesor = cuaderno.cuaderno_profesores.find((cp) => (
      cp.profesor.id === idProfesor
    ));

    // Solo se pueden importar los cuadernos que el profe es titular, los de refuerzo no
    return cuadernoProfesor?.tipo === 'titular';
  });
}
/*
  Gestión del modal de importar items de otro cuaderno
*/
/* global Mn, Backbone, Cifra, $ */
const ImportarItemsCuaderno = Mn.View.extend({
  template: noop,
  ui: {
    cuadernoActual: '#origen_cuaderno_actual_id',
    botonSubmit: '[type="submit"]',
    annoLectivo: '#origen_anno_lectivo_id',
    profesor: '#origen_profesor_id',
    cuaderno: '#origen_cuaderno_id',
    cuadernoProfesor: '#origen_cuaderno_profesor_id',
  },
  events: {
    'change @ui.annoLectivo': 'cambiaAnnoLectivo',
    'change @ui.cuaderno': 'cambiaCuaderno',
    'change @ui.cuadernoProfesor': 'cambiaCuadernoProfesor',
    'change select': 'checkSubmitDisabled',
  },
  onRender() {
    const view = this;
    const $selectorEstructura = this.$el.find('.selector-estructura');

    // La vista de "Mis cuadernos" no tiene selector
    if ($selectorEstructura) {
      if (!this._conectarSelectorEstructura()) {
        $selectorEstructura.on(EVENTO_CONTROLLER_CARGADO, () => {
          view._conectarSelectorEstructura();
        });
      }
    }

    this.selectCuadernos = new Cifra.Components.Select({
      el: view.$el.find(this.getUI('cuaderno')),
      collection: new Backbone.Collection({}, {
        comparator: 'nombre',
      }),
      showEmpty: false,
    });

    this.selectAsignaturas = new Cifra.Components.Select({
      el: view.$el.find('#origen_asignatura_id'),
      collection: new Backbone.Collection({}, {
        comparator: 'nombre',
      }),
      showEmpty: false,
    });

    this.selectProfesores = new Cifra.Components.Select({
      el: view.$el.find('#origen_cuaderno_profesor_id'),
      collection: new Backbone.Collection({}, {
        comparator: 'nombre',
      }),
      showEmpty: false,
    });

    this.selectProfesores.on('render', function onRender() {
      // En el render (se actualizan los options), conectamos con chained
      this.$el.chained('#origen_asignatura_id');
    });

    this.selectPestanas = new Cifra.Components.Select({
      el: view.$el.find('#origen_pestana_id'),
      collection: new Backbone.Collection({
        comparator: 'nombre',
      }),
      showEmpty: false,
    });

    if (this.getUI('annoLectivo').val()) {
      this.getUI('annoLectivo').change();
    }

    view.checkSubmitDisabled();
  },
  grupoSeleccionado(idGrupo) {
    const view = this;
    $.get(`/grupos/${idGrupo}/cuadernos_json`).done((data) => {
      const profesores = [];
      view.selectAsignaturas.collection.reset(map(data, (cuaderno) => {
        each(cuaderno.cuaderno_profesores, (cuadernoProfesor) => {
          const { profesor } = cuadernoProfesor;
          profesores.push({
            id: cuadernoProfesor.id,
            nombre: profesor.nombre_completo,
            data: {
              chained: cuaderno.asignatura.id,
            },
          });
        });

        return {
          id: cuaderno.asignatura.id,
          nombre: cuaderno.asignatura.nombre,
        };
      }));
      view.selectProfesores.collection.reset(profesores);
      view.checkSubmitDisabled();

      view.selectCuadernos.collection.reset(data);
      view.cambiaCuaderno();
    });
  },
  cargarCuadernos(annoLectivoId) {
    const view = this;
    const params = {
      anno_lectivo_id: annoLectivoId,
    };
    const idProfesor = Number.parseInt(this.getUI('profesor').val(), 10);
    $.get(`/profesores/${idProfesor}/cuadernos_json`, params).done((data) => {
      view.selectCuadernos.collection.reset(filtrarCuadernosValidos(idProfesor, data));
      view.cambiaCuaderno();
    });
  },
  checkSubmitDisabled() {
    const $form = this.$el.find('form');
    // Origen es el namespace bajo el que está el formulario
    const datos = Backbone.Syphon.serialize($form).origen;
    // Esta comprobación es para el formulario de "Otros cuadernos"
    let habilitar;
    if ($form.hasClass('mis-cuadernos')) {
      habilitar = datos.cuaderno_id && datos.pestana_id;
    } else {
      habilitar = datos.grupo_id && datos.asignatura_id
        && datos.cuaderno_profesor_id && datos.pestana_id;
    }
    this.getUI('botonSubmit').prop('disabled', !habilitar);
  },
  // Cambia el selector del año lectivo de "Mis cuadernos"
  cambiaAnnoLectivo() {
    this.cargarCuadernos(this.getUI('annoLectivo').val());
  },
  cargarPestanas(cuadernoId) {
    const view = this;
    $.get(`/cuadernos/calificaciones/${cuadernoId}/info`).done((data) => {
      view.selectPestanas.collection.reset(data.info_cuaderno.pestanas || []);
      view.checkSubmitDisabled();
    });
  },
  cargarPestanasCuadernoProfesor(cuadernoProfesorId) {
    const view = this;
    $.get(`/cuadernos/calificaciones/${this.getUI('cuadernoActual').val()}/importar_items_cuaderno/info_cuaderno_profesor/${cuadernoProfesorId}`).done((data) => {
      view.selectPestanas.collection.reset(data.pestanas || []);
      view.checkSubmitDisabled();
    });
  },
  // Cambia el selector del cuaderno en "Mis cuadernos"
  cambiaCuaderno() {
    const cuadernoId = this.getUI('cuaderno').val();
    if (cuadernoId) {
      const cuaderno = this.selectCuadernos.collection.get(Number.parseInt(cuadernoId, 10));
      if (cuaderno) {
        this.cargarPestanas(cuaderno.id);
      }
    } else {
      this.selectPestanas.collection.reset();
      this.checkSubmitDisabled();
    }
  },
  cambiaCuadernoProfesor() {
    const cuadernoId = this.getUI('cuadernoProfesor').val();
    if (cuadernoId) {
      this.cargarPestanasCuadernoProfesor(cuadernoId);
    } else {
      this.selectPestanas.collection.reset();
      this.checkSubmitDisabled();
    }
  },
  _conectarSelectorEstructura() {
    const view = this;
    const $selectorEstructura = this.$el.find('.selector-estructura');
    this.selectorGrupo = window.Stimulus.getControllerForElementAndIdentifier(
      $selectorEstructura[0], 'selector-estructura',
    );
    if (!this.selectorGrupo) {
      return false;
    }
    this.selectorGrupo.component.on('option:selected', (type, selectedId, _path) => {
      if (type !== 'grupo') {
        return;
      }
      view.grupoSeleccionado(selectedId);
    });
    return true;
  },
});

export default class extends ApplicationController {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new ImportarItemsCuaderno(options);
    this.component.render();
  }
}
